import React, { useCallback } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import './datatable.scss';
import * as DT from './model';
import getSelectColumnDefinition from './selectColumn';

const styleDefault = 'datatable__table  -highlight'; /* -striped */
const pageSizeOptionsDefault = [5, 15, 30, 50, 100];

interface OwnProps<T> {
  rows: T[];
  getPK: DT.GetPkType<T>;
  getTrProps?: any;
  columns: DT.TableColumn[];
  isLoading: boolean;
  isSelectable?: boolean;
  isMultiSelect?: boolean;
  allSelected?: boolean;
  isItemSelected?: DT.IsItemSelectedType<T>;
  onToggleItemSelection?: DT.ToggleItemType<T>;
  onToggleAllSelected?: DT.ToggleSelectAllType;
  pagination: DT.TablePagination;
  onPageChange?: DT.OnPageChangeType;
  onPageSizeChange?: DT.OnPageSizeChangeType;
  pageSizeOptions?: number[];
  sortCriteria: DT.SortCriteria[];
  onSortCriteriaChanged?: DT.OnSortCriteriaChangedType;
  className?: string;
}

type IProps<T extends {}> = OwnProps<T>;

function Datatable<T extends {}>(props: IProps<T>) {
  const { isItemSelected, onToggleItemSelection, onToggleAllSelected } = props;
  const fnIsItemSelected = useCallback(
    (item: T) => (isItemSelected ? isItemSelected(item) : false),
    [isItemSelected]
  );
  const fnToggleItem = useCallback(
    (item: T) => onToggleItemSelection && onToggleItemSelection(item),
    [onToggleItemSelection]
  );
  const fnToggleSelectAll = useCallback(
    () => onToggleAllSelected && onToggleAllSelected(),
    [onToggleAllSelected]
  );

  const allSelected = props.allSelected || false;

  let columns = [...props.columns];
  const isMultiSelect = !(props.isMultiSelect === false);
  if (props.isSelectable) {
    columns = [
      getSelectColumnDefinition(
        allSelected,
        fnToggleSelectAll,
        fnToggleItem,
        fnIsItemSelected,
        props.getPK,
        isMultiSelect
      ),
      ...columns,
    ];
  }

  return (
    <ReactTable
      noDataText=""
      loading={props.isLoading}
      data={props.rows}
      getTrProps={props.getTrProps}
      columns={columns}
      pageSizeOptions={props.pageSizeOptions || pageSizeOptionsDefault}
      className={props.className || styleDefault}
      manual
      pages={props.pagination.numPages}
      page={props.pagination.currentPage - 1}
      pageSize={props.pagination.pageSize}
      onPageChange={props.onPageChange}
      onPageSizeChange={props.onPageSizeChange}
      sorted={props.sortCriteria}
      onSortedChange={props.onSortCriteriaChanged}
    />
  );
}

export default Datatable;
